import { useMutation, useQueryClient } from 'react-query'

import {
  type POBillToPrimaryCategorySystemPreference,
  SystemPreferenceKeys,
  SystemPreferencesRepository,
  systemPreferencesKeys,
} from '@webapp/platform/iam'

export const useMutatePOBillToPrimaryCategory = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (value: POBillToPrimaryCategorySystemPreference['value']) =>
      SystemPreferencesRepository.updateSystemPreference(
        SystemPreferenceKeys.PO_BILL_TO_LOCATION,
        value
      ),
    onSuccess: () => queryClient.invalidateQueries(systemPreferencesKeys.all),
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
